import React from 'react'
import USTemplateDefault from 'src/components/template/us'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={'https://assets.fubo.tv/marketing/lp/videos/compressed/stream-fx-networks-2021.mp4'}
    title="Watch FX with Fubo"
    subtitle="Enjoy hit entertainment, live and on demand"
    customNetworks={['fx']}
  />
)
